export default {
    login: 'user/quick_login', // 登录
    userInfo: 'user/get_user_info', // 获取用户信息
    getgoods: 'getgoods', // 测试
    token: 'token',
    insertLists: 'insertLists',
    selectPage: 'selectPage',
    getCarNoBelongTo: 'index/get_car_mark_list', // 获取车牌归属地
    getAreaList: 'index/get_region_list/', // 获取地区列表
    getPaymentsList: 'pay/get_enable_payments', // 获取支付方式
    getGraphValidateCode: 'index/draw_verify_pic', // 获取图形验证码
    getSmsCode: 'index/send_auth_sms_captcha', // 获取短信验证码
    getGoodsInfo: 'goods/get_goods_info', // 获取商品信息
    getGoodsSpecList: 'goods/get_goods_spec_list', // 获取规格信息
    getAddressList: 'order/get_address_list', // 获取收货地址
    getAllRegionList: 'index/get_all_region_list/', // 获取所有省市区地址
    getOrderConfirm: 'order/order_confirm', // 获取订单
    saveAddress: 'order/save_address', // 新增或者编辑地址修改
    getAddressInfoById: 'order/get_info', // 根据收货地址查询详情数据
    delAddressById: 'order/del_address', // 根据收货地址查询详情数据
    orderCreate: 'order/order_create', // 创建订单
    getMarketingInfo: 'marketing/get_h5_marketing_info', // 获取营销内容详情
    getMarketingImgs: 'marketing/get_marketing_album', // 获取营销内容图册
    outTradeNo: 'pay/get_out_trade_no', // 统一下单接口
    payedOrder: 'pay/get_promotion_payed_order', // 查询交易成功页面
    notify: 'pay/notify_order_pay', // 根据流水号号判断订单是否已支付
    wxconfig: 'pay/get_weixin_config', // 微信配置
    wxUserInfo: 'user/get_wechat_user_info', // 获取微信用户信息
    loginWx: 'user/login_wx', // 获取微信用户信息
    bindMobile: 'user/bind_mobile', // 绑定手机号
    sendBoundMsg: 'user/send_bound_msg', // 发送绑定的消息模板通知
    getSpecialActivity: 'activity/detail', // 获取特殊活动页面商品数据
    getFloorList: 'activity/floor_detail', // 获取楼层数据(多店推广、单店推广)
    getShopJudge: 'activity/check_goods_status', // 判断商品是否过期
    getAllStoreList: 'activity/get_all_sstores', // 获取活动全部门店
    getNearbySstores: 'activity/get_nearby_sstores', // 获取活动门店-分页
    getClosestSstores: 'activity/get_closest_sstores', // 获取最近门店-单店信息
    getGoodsList: 'activity/goods_list', // 获取活动商品列表
    topicDetail: 'activity/topic_detail', // 获取推广详情
    getSeckillInfo: 'seckill/get_seckill_info', // 获取秒杀主题信息
    getSeckillGoodsList: 'seckill/get_seckill_goods_list', // 获取秒杀主题商品信息
    cancelRemind: 'seckill/seckill_goods_cancel_remind', // 取消秒杀提醒
    sendSmsCaptcha: 'seckill/send_sms_captcha', // 发送秒杀短信通知短信
    seckillGoodsRemind: 'seckill/seckill_goods_remind', // 添加秒杀商品提醒
    getDistributionActivityInfo: 'distribution/get_special_info', // 获取分销活动信息
    getDistributionActivityGoodsList: 'distribution/get_special_goods_list/', // 获取分销活动商品列表
    getDistributionDetail: 'distribution/goods_info', // 获取分销商品信息
    getDistributioGoodsSpecList: 'distribution/get_goods_spec_list', // 获取分销规格信息
    getDistributioStroreList: 'distribution/get_sstore_list', // 获取分销门店列表
    getSendSmsCount: 'index/get_send_times', // 获取验证码发送次数
    bindDistributor: 'distribution/bind_distributor', // 绑定分销员
    // 保养
    getAdviceList: 'maintain/get_maintain_info', // 获取保养建议页列表 - 根据保养营销id获取营销信息
    sendTipsStore: 'maintain/set_is_show_notice', // 发送门店服务上架提示
    getServiceDetail: 'maintain/get_sstore_goods_info', // 获取门店服务详情
    getAdviceServicesList: 'maintain/get_service_goods_list', // 获取门店服务列表
    getAdviceGoodsList: 'maintain/get_sstore_goods_list', // 获取门店分商品列表
    getGoodsSkuInfo: 'maintain/get_goods_spec_list', // 获取商品规格列表
    getAdviceGoodsData: 'maintain/get_spec_info', // 获取规格详细接口
    // 推广
    aggregationTopicDetail: 'activity/aggregation_topic_detail', // 聚合推广详情
    getMarketingActivities: 'ServicePackage/get_service_package_detail', // 获取营销活动详情数据
    goBuy: 'order/package_order_create', // 营销活动详情立即购买
    getOrderInfo: 'order/package_order_confirm', // 获取营销活动确认订单数据
    paySuccess: 'pay/pay_success_ad', // 或缺营销活动交易成功信息
    getDistributorMall: 'Distribution/get_my_distribution_mall', // 获取分销员商城数据
    getDistributionList: '/Distribution/distributed_goods_list', // 获取分销商品列表
    getCarBrand: 'index/get_brand', // 获取车辆品牌
    getCarLine: 'index/get_line', // 获取车系
    getCarModel: 'index/get_car', // 获取车型
    debitcard: 'pay/pay_order', // 储值卡支付
    getClassification: 'goods/get_cate_list', // 获取商品分类列表
    getDistributorInfo: 'Distribution/get_distributor_info', // 获取分销员信息

    getDiscountServiceList: 'Distribution/get_service_package_list', // 获取特惠服务列表
    getDiscountServiceTags: 'Distribution/get_service_package_tag', // 获取特惠服务筛选标签
    getRecommendStoreList: 'Distribution/get_distribution_mall_store_list', // 获取分销门店列表
    getStoreHomeInfo: 'Distribution/get_distribution_mall_store_details', // 获取分销门店主页信息
    aggregationFloorListGet: 'activity/floor_list', // 聚合推广楼层

    // v2.05 统计接口
    addVisitLog: 'user/add_visit_log', // 聚合推广楼层

    // v2.6
    // getPromotionInfo: 'StoreActivity/custom_activity', // 获取自定义推广详情页面主体信息
    getPromotionInfo: 'StorePopularizeActivity/custom_activity', // 获取自定义推广详情页面主体信息 v2.9 修改
    getPromotionGoodsInfo: 'StorePopularizeActivity/goods_list', // 获取（自定义推广详情、常规推广详情）页面商品列表信息
    getRegularInfo: 'StoreActivity/common_activity', // 获取常规推广详情页面主体信息
    getStoreInfo: 'Sstore/info', // 获取门店信息
    getCityList: 'StoreActivity/get_city_list', // 获取城市列表
    selectHotCity: 'StoreActivity/select_hot_city', // 获取热门
    selectAddress: 'StorePopularizeActivity/map_search_address', // 选择地址
    getSpecSstores: 'StorePopularizeActivity/get_sstore_list', // 商家推广分页-获取推广专题所有有效代理门店
    getMoreSstoreGoodsDetail: 'StoreActivity/goods_info', // 获取商家营销推广商品详情
    getMoreSstoreGoodsDetailSpecList: 'StoreActivity/get_goods_spec_list', // 获取商家营销推广商品详情
    // v2.5优惠券
    getCouponInfo: 'ServiceCoupon/get_coupon_info', // 优惠券详情
    getCoupon: 'ServiceCoupon/get_coupon', // 领取优惠券
    getServiceCouponList: 'ServiceCoupon/get_service_coupon_list', // 获取用户可领和可用优惠券
    getCouponListByService: 'ServiceCoupon/get_coupon_list_by_service', // 根据服务获取用户优惠券可用的列表
    createBdCouponOrder: 'ServiceCoupon/create_bd_coupon_order', // 购买bd优惠券
    getBdCouponUseSstoreList: 'ServiceCoupon/get_bd_coupon_use_sstore_list', // bd优惠券-可用券门店列表
    zeroPay: 'pay/zero_purchase', // 0元支付订单
    // v2.7 短信营销
    getAggregationInfo: 'SstoreSmsTopic/get_info', // 获取单店聚合页页面信息
    getAggregationList: 'SstoreSmsTopic/get_front_list', // 获取单店聚合页列表信息
    getAggregationSearchList: 'SstoreSmsTopic/get_list', // 获取单店聚合搜索页搜索结果
    getAggregationInitSearchList: 'SstoreSmsTopic/get_goods_service_list', // 获取单店聚合搜索页初始数据
    // v2.76或者最近活动
    getNewlyActivity: 'activity/get_newly_activity', // 获取最新活动信息

    // v2.9
    getPromotionFloorInfo: 'StorePopularizeActivity/get_floor_goods_list', // 获取楼层数据（包含特惠活动）
    feedback: 'StorePopularizeActivity/add_feedback', // 反馈
    getBusinessSstoreListMap: 'StorePopularizeActivity/sstore_list_map', // 商家推广门店地图模式
    getScanSstore: 'StorePopularizeActivity/get_scan_sstore', // 获取物料二维码扫码的门店id

    // v2.95
    getCouponList: 'ServicePackage/get_package_coupon_list', // 获取营销活动详情数据
    getCouponListByPackage: 'ServicePackage/get_coupon_list', // 根据套餐包获取用户优惠券可用的列表
}
